import React from "react";
import "./FreeTrial.scss";
import messages from "assets/Local/messages";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const FreeTrial = () => {
  const lang = useSelector((state) => state.locale.lang);
  const message = messages[lang];

  return (
    <div className="container">
      <div className="trial">
        <div className={lang==='ar'?'bg-gradient-ar':'bg-gradient-en'}>
          <div className="row justify-content-between align-items-center position-relative">
            <div className="trial__content c text-white">
              <h2 className="text-uppercase text-white bold_font">{message.pricingPage.freeTrial}</h2>
              <ul className="d-flex mt-2 mt-md-4 p-0 mb-0">
                <li className="mx-3 regular_font">{message.pricingPage.free}</li>
                <li className="mx-3 mx-lg-4 regular_font">
                  {message.pricingPage.noFees}
                </li>
                <li className="mx-3 mx-lg-4 regular_font">
                  {message.pricingPage.NoCreditCard}
                </li>
              </ul>
            </div>
            <Link to="registration">
              <button
                className={`text-center d-flex justify-content-center align-items-center rounded-circle bg-white ${
                  lang === "ar" ? "trial__btn_ar" : "trial__btn"
                }`}
              >
                {lang === "ar" ? (
                  <h2 className="text-uppercase  bold_font">
                    جرب <br />
                    الان
                  </h2>
                ) : (
                  <h2 className="text-uppercase bold_font ">
                  try<br/> now 
                  </h2>
                )}
              </button>
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
};
